export var labels = [
  'view',
  '_empty',
  'clearall',
  '_format',
  '_webhome',
  '_nbproduct',
  'tags',
  'categories',
  'qte',
  '_webaddtocart',
  'qtyinstock',
  'web_outofstock',
  'web_orderby',
  '_webservererror',
  '_sortByNameAsc',
  '_sortByNameDesc',
  '_sortByPriceAsc',
  '_sortByPriceDesc',
  '_webbacktotop',
  'filter'
];